import  {useState, useEffect} from 'react'
import {KTCard, KTCardBody} from '../../../_metronic/helpers'
import Dropdown from 'react-bootstrap/Dropdown'
import plusIcon from '../../../_metronic/images/smlplus.svg'
import {GET_ALL_SCRIPTS_LIST, DELETESCRIPT} from '../../../utils/GraphQLAPI'
import {useLazyQuery, useMutation} from '@apollo/client'
import {Spinner} from 'react-bootstrap'
import {UsersListPagination} from '../../modules/apps/user-management/users-list/components/pagination/UsersListPagination'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import '../../pages/TeamAdmin/TPVScript/overrideBootstrap.css'
import CreateScript from './CreateScript'
import {alert} from '../../../utils/helper'

const MySwal = withReactContent(Swal)

const ScriptList = ({settingsAdded}: any) => {
  const [showModal, setShowModal] = useState(false)
  const [modalConfig, setModalConfig] = useState({})
  const [removeScript, setRemoveScript] = useState()
  const [listOptions, setListOptions] = useState<any>({
    commodityId: null,
    isActive: null,
    languageId: null,
    page: 1,
    perPage: 10,
    salesChannelId: null,
    searchText: '',
    utilityId: null,
  })


  const [fetchedValue, setFetchedValue] = useState<any>([])
  const [pageNo, updatePageNo] = useState<any>(0)

  const [csv, setCsv] = useState<boolean>(false)
  //for Modal
  const [loadedData, setLoadedData] = useState(false)
  const audio = new Audio()
  const networkOnly = 'network-only'
  const AreYouSureMsg = 'Are you sure?'
  const noCancelMsg = 'No, cancel !'
  const cancelBtnClr = 'rgb(39 37 37 / 52%)'

  const [getScriptList, {loading, refetch}] = useLazyQuery(GET_ALL_SCRIPTS_LIST, {
    variables: {
      getScriptsInput: listOptions,
    },
    onCompleted: (data) => {
      setFetchedValue({
        scripts: [
          {
            prompts: 'This is a Example Message',
            scriptId: '6347a8e3-5254-4024-8ae9-8e1bb1c4f2fd',
            scriptName: 'Script Name',
          },
        ],
        totalCount: 1,
        __typename: 'ScriptListResponse',
      })
    },
    onError: (err) => console.log('error', err),
    fetchPolicy: networkOnly,
  })
  const [deleteScript] = useMutation(DELETESCRIPT, {
    variables: {
      scriptId: removeScript,
    },
    onCompleted: () => {
      alert('Script deleted successfully', 'success')
      refetch()
    },
    onError: (err) => {
      alert(err.message, 'warning')
    },
  })



  useEffect(() => {
    getScriptList()
  }, [listOptions])

  useEffect(() => {
    setListOptions((prevOptions: any) => {
      return {...prevOptions, page: pageNo + 1}
    })
  }, [pageNo])

  const updateRowsPerPage = (value: any) => {
    setListOptions((prevOptions: any) => {
      return {...prevOptions, perPage: value, page: pageNo + 1}
    })
  }

  const handleOpenModal = (mode: any, scriptId = '') => {
    if (settingsAdded) {
      setLoadedData(false)
      setModalConfig({
        mode,
        scriptId,
      })
      setShowModal(true)
    } else {
      MySwal.fire({
        icon: 'warning',
        title: 'Please complete script settings before adding a script',
      })
    }
  }

  
  return (
    <KTCard>
      <div className='card card-custom'>
        <div className=' card-header card-body pb-0 border-0'>
          <div className='card-toolbar flex-row-fluid justify-content-end gap-5'>
            <button
              className='btn btn-primary fs-6'
              data-bs-toggle='modal'
              data-bs-target='#create-script'
              onClick={() => handleOpenModal('create')}
            >
              <img src={plusIcon} alt='' className='svg-icon svg-icon-1' />
              <span>Create Script</span>
            </button>
            <CreateScript
              show={showModal}
              modalConfig={modalConfig}
              setShowModal={setShowModal}
              getScriptList={getScriptList}
            //   loadedData={loadedData}
            //   setLoadedData={setLoadedData}
            //   audio={audio}
            />
          </div>
        </div>
        <KTCardBody className='pe-0 min-h-lg-450px min-h-md-300px' scroll={loading ? false : true}>
          {loading ? (
            <div className='text-center'>
              <Spinner animation='border' className='text-gray-600' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </Spinner>
            </div>
          ) : fetchedValue.totalCount !== 0 ? (
            <div className='table-responsive-xxl'>
              <table className='table table-row-dashed gy-7 gs-7'>
                <thead>
                  <tr className='fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200 table_row'>
                    <th className='header_title header_title_spacing'>Script Name</th>
                    <th className='header_title header_title_spacing'>Message</th>
                  </tr>
                </thead>
                <tbody>
                  {fetchedValue &&
                    fetchedValue?.scripts?.map((item: any, index: number) => {
                      return (
                        <tr className='border-bottom-2 name_spacing'>
                          <td
                            className='name'
                            style={{cursor: 'pointer'}}
                            onClick={() => handleOpenModal('preview', item.scriptId)}
                          >
                            {item.scriptName != null ? item.scriptName : '-'}
                          </td>
                          <td className='content'>{item.prompts != null ? item.prompts : '-'}</td>

                          <td className='text-gray-600 fs-6 ps-0 fw-semibold'>
                            <Dropdown className='show-override'>
                              <Dropdown.Toggle
                                id='dropdown-custom-1'
                                className='text-gray-600 btn btn-sm btn-icon btn-active-light-primary btn-light-primary btn-arrow-overide'
                                style={{background: 'none!important'}}
                              >
                                <i className='bi bi-three-dots-vertical fs-7 text-primary'></i>
                              </Dropdown.Toggle>
                              <form>
                                <Dropdown.Menu className=' py-2 menu-state-bg-primary'>
                                  <Dropdown.Item
                                    as='div'
                                    className='text-gray-600 fs-7 menu-item p-0'
                                  >
                                    <div
                                      className='menu-link'
                                      onClick={() => handleOpenModal('edit', item.scriptId)}
                                    >
                                      Edit
                                    </div>
                                  </Dropdown.Item>

                                  <Dropdown.Item
                                    as='div'
                                    className='text-gray-600 fs-7 menu-item p-0'
                                  >
                                    <div
                                      className='menu-link text-danger text-hover-white'
                                    >
                                      Delete
                                    </div>
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </form>
                            </Dropdown>
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className='fs-4 fw-semibold text-center text-muted min-h-400px d-flex-align-items-center justify-content-center'>
              <div>No Results Found</div>
            </div>
          )}
        </KTCardBody>
        {fetchedValue?.totalCount > 0 ? (
          <div className='card-footer border-0'>
            <UsersListPagination
              page={pageNo}
              total={fetchedValue.totalCount}
              updatePage={updatePageNo}
              recordsPerPage={(e: any) => {
                updateRowsPerPage(parseInt(e))
              }}
              rowsPerPage={listOptions.perPage}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </KTCard>
  )
}

export default ScriptList
